/**
 * Reglas compartidas para activar depuración por **variable `VITE_*`** y/o **`localStorage`**.
 *
 * Política del repo: toda depuración normada debe poder activarse de **ambas** formas
 * (rebuild con `.env` o sin rebuild desde la consola del navegador). Ver
 * `docs/500-guias/logs-debug-y-flags.md`.
 */

/** `VITE_*=true` en `.env` (tras reiniciar `pnpm start`). */
export function viteEnvDebugTrue(value: string | undefined): boolean {
  return typeof value === 'string' && value.trim() === 'true'
}

/** Claves en `localStorage`: `1` o `true` (sin distinguir mayúsculas en el valor). */
export function localStorageDebugOn(value: string | null | undefined): boolean {
  if (value === null || value === undefined) return false
  const v = value.trim().toLowerCase()
  return v === '1' || v === 'true'
}
